module.exports = __webpack_public_path__ + "static/media/1348_Requests_elements.3bc5323e.png";